export default "__VITE_ASSET__Bwn5rivp__"